<!-- 页底流程 -->
<template>
  <div class="follow">
    <div class="followCon width">
      <div class="followItem">
        <div class="followItemLeft">
          <img src="../assets/images/u903.png" alt srcset />
          <h3>注册登录平台</h3>
        </div>
        <div class="followItemRight">
          <img src="../assets/images/u893.svg" alt srcset />
        </div>
      </div>
      <div class="followItem">
        <div class="followItemLeft">
          <img src="../assets/images/u904.png" alt srcset />
          <h3>进入控制台实名认证</h3>
        </div>
        <div class="followItemRight">
          <img src="../assets/images/u893.svg" alt srcset />
        </div>
      </div>
      <div class="followItem">
        <div class="followItemLeft">
          <img src="../assets/images/u905.png" alt srcset />
          <h3>选择解决方案</h3>
        </div>
        <div class="followItemRight">
          <img src="../assets/images/u893.svg" alt srcset />
        </div>
      </div>
      <div class="followItem">
        <div class="followItemLeft" style="background-color: #32a8ff;">
          <img src="../assets/images/u900.png" alt srcset />
          <h3 style="color:#fff">提交方案咨询</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.follow {
  background-color: #fff;
  padding-top: 230px;
  padding-bottom: 60px;
  margin-bottom: 10px;
  .followCon {
    display: flex;
    justify-content: center;
    align-items: center;
    .followItem {
      flex: 2;
      display: flex;
      // justify-content: center;
      align-items: center;
      .followItemLeft {
        flex: 2;
        width: 230px;
        max-width: 230px;
        height: 160px;
        background-color: rgba(242, 242, 242, 1);
        border-radius: 4px;
        text-align: center;
        img {
          width: 60px;
          text-align: center;
          color: #32a8ff;
          padding-top: 30px;
        }
        h3 {
          font-weight: 700;
          color: #32a8ff;
          font-size: 18px;
          text-align: center;
        }
      }
    }
    .followItem:last-child {
      flex: 1;
    }
    .followItemRight {
      flex: 1;
      margin-left: 20px;
      text-align: center;
    }
  }
}
</style>
